import { BLOCK_SCHEMA_DICTIONARY } from '../Blocks/BlockSettings.js'
import Normalizer from '../util/normalizer.js'
import DataSchema from '../util/schema.js'
import { genUniqueId } from '../../../../../common/utils/genUniqueId.js'

export default class Page {
    id
    name
    blocks

    constructor({ name = '', blocks = [] }) {
        this.id = genUniqueId()
        this.name = name
        this.blocks = blocks.map(block => {
            const newBlock = new Normalizer(new DataSchema(BLOCK_SCHEMA_DICTIONARY[block.t])).process(block)
            return { ...newBlock, id: genUniqueId() }
        })
    }

    static get name() {
        return 'name'
    }

    static get blocks() {
        return 'blocks'
    }
}
